import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Modal, Row, Col, Spin } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { getDeliveryEntries } from 'util/deliveryEntries';

const DeliveryProofsButton = ({ packageId, signatureImage }) => {
  const [visible, setVisible] = useState(false);
  const [urls, setUrls] = useState(null);

  const handleClick = async () => {
    setVisible(true);
    if (urls) return;
    const entries = await getDeliveryEntries(packageId, signatureImage);
    if (entries.length > 0) setUrls(entries.map((entry) => entry.url));
  };

  return (
    <>
      <Button icon={<PictureOutlined />} onClick={handleClick}>
        Ver pruebas
      </Button>
      <Modal
        title="Evidencia de entrega"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        centered
      >
        {urls ? (
          <Image.PreviewGroup>
            <Row gutter={[8, 8]}>
              {urls.map((url) => (
                <Col key={url} span={8}>
                  <Image src={url} />
                </Col>
              ))}
            </Row>
          </Image.PreviewGroup>
        ) : (
          <Row justify="center" style={{ padding: 24 }}>
            <Spin size="large" />
          </Row>
        )}
      </Modal>
    </>
  );
};

DeliveryProofsButton.propTypes = {
  packageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  signatureImage: PropTypes.string,
};

DeliveryProofsButton.defaultProps = {
  signatureImage: null,
};

export default DeliveryProofsButton;
